import { track } from 'telemetry';
import { ETelemetryActionsAndLabels, ETelemetryNames } from 'telemetry/type';
import isEmpty from 'lodash/isEmpty';

export enum ButtonNames {
    LegalTerms = 'LegalTerms',
    SubmitRequest = 'SubmitRequest',
}

export const trackClickInCancellation = (buttonName: ButtonNames, cancelReason?: string, uuid = '') => {
    track(ETelemetryNames.Cancellation, {
        action: ETelemetryActionsAndLabels.Click,
        label: ETelemetryActionsAndLabels.Click,
        clickData: {
            buttonName,
            cancelReason,
            uuid,
        },
    });
};

export type CancellationTrackCreateData = {
    cancelReason: string;
    actualError?: string;
    status: 'success' | 'failed';
    uuid: string;
};

export const trackCreateInCancellation = (createData: CancellationTrackCreateData) => {
    track(ETelemetryNames.Cancellation, {
        action: ETelemetryActionsAndLabels.Create,
        label: ETelemetryActionsAndLabels.Create,
        createData,
    });
};

export const isValidEncryptedSerialNumberString = (encryptedSerialNumberString: string): boolean => {
    return /^\d+\|.*?$/.test(encryptedSerialNumberString);
};
export const formatEncryptedSerialNumberString = (
    encryptedSerialNumberString: string,
): { initialSerialNumber: string; productName: string } => {
    let initialSerialNumber: string;
    let productName: string;
    if (isValidEncryptedSerialNumberString(encryptedSerialNumberString)) {
        const splitStart = encryptedSerialNumberString.indexOf('|');
        initialSerialNumber = encryptedSerialNumberString.slice(0, splitStart);
        productName = encryptedSerialNumberString.slice(splitStart + 1);
    } else {
        initialSerialNumber = '';
        productName = '';
    }
    return {
        initialSerialNumber,
        productName,
    };
};

export const formattedSerialNumberString = (serialNumber: string, productName: string) => {
    const formatProductName = isEmpty(productName) ? '' : ` (${productName})`;
    return isEmpty(serialNumber) ? '' : `${serialNumber}${formatProductName}`;
};
